import Snappy from '../../../libs/snappy/snappy';
import $ from 'jquery';


Snappy.Component.Cookie = class Cookie extends Snappy.BaseComponent {
    static get tagName() {
        return 'fa-cookie';
    }


    setVars() {
        this.$button = this.$element.find('.accept-cta');
        this.cookieVisibilityKey = 'fa-cookie-visible';
        this.isCookieMessageVisible = this.getCookieMessageVisibility();
        this.activeClass = 'active';
        this.surveyVisibilityKey = 'fa-survey-visible';
        var surveyUniqueID = $('.SurveyUniqueID');
        if (surveyUniqueID.length) {
            this.SurveyUniqueID = surveyUniqueID.text();
        }
        this.surveyAlreadyActionedByUserKey = 'fa-survey-actioned' + this.SurveyUniqueID;

    }

    setEventListeners() {
        this.$button.on('click', this.acceptCookies.bind(this));
    }

    
    getCookieMessageVisibility() {
        let visible = JSON.parse(localStorage.getItem(this.cookieVisibilityKey));

        if (visible === null) {
            // no preference stored, so message should be shown
            visible = true;
        }

        return visible;
    }

    setCookieMessageVisibility(visible) {
        localStorage.setItem(this.cookieVisibilityKey, visible);
    }

    hideCookieMessage() {
        this.$element.removeClass(this.activeClass);
    }

    constructor(element) {
        super(element);
    }

    render() {
        
        this.setVars();
        this.setEventListeners();
        this.showCookieMessage();
    }


    showCookieMessage() {

        if (this.isCookieMessageVisible) {
            this.$element.addClass(this.activeClass);
        }
        else {
            //alert("show survey");
            this.displaySurvey();
        }

    }    

    acceptCookies() {

        this.hideCookieMessage();
        this.setCookieMessageVisibility(false);
        this.displaySurvey();
    }


    displaySurvey() {
        if (this.getSurveyAlreadyActionedByUser()) return; //User has already seen and accepted/declined the survey        

        var surveyVisible = localStorage.getItem(this.surveyVisibilityKey);
        if ((surveyVisible != null) && (surveyVisible == 'True'))
        {
            //alert("survey triggered in past");
            //user has already accepted the cookie in past and survey has been triggered
            this.incrementCurrentUserNumberAjax();
            this.getDisplaySurveyAfterTimeInSecondsAndDisplay();
        }
        else
        {
            //Triggered when user accepts the cookie
            //OR            
            //if cookie message has been accepted in another session and survey has not been shown yet
            //alert("accept cookie");
            let cookieAccepted = localStorage.getItem(this.cookieVisibilityKey);
            if (cookieAccepted != null && cookieAccepted != "True") //cookie has been accepted
            {
                var surveyEnabled = $('.survey-Enabled');//Is survey enabled
                if ((surveyEnabled.length) && ((surveyEnabled.text().toLowerCase()) == "true")) {
                    var displayToCurrentVisitor = $('.survey-DisplayToCurrentVisitor');//Should survey be shown to current visitor
                    if ((displayToCurrentVisitor.length) && (displayToCurrentVisitor.text().toLowerCase() == "true")) {
                        localStorage.setItem(this.surveyVisibilityKey, "True");//set survey localstorage to visible                
                        this.incrementCurrentUserNumberAjax();
                        this.getDisplaySurveyAfterTimeInSecondsAndDisplay();
                    }
                }
            }
        }
    }

    //Ajax call to get information from server
    getDisplaySurveyAfterTimeInSecondsAndDisplay() {
        var serviceURL = $(".DisplaySurveyAfterInSecondsUrl").text();
        var displayAfterTimeInSurveyItemInSeconds = $('.survey-DisplayAfterTime').text();
        $.ajax({
            type: "GET",
            url: serviceURL,
            dataType: "json",
            data: { displayAfterTimeInSurveyItemInSeconds: displayAfterTimeInSurveyItemInSeconds },
            success: successFunc,
            error: errorFunc
        });
        function successFunc(returnedData) {
            var displayAfterTime = parseInt(returnedData);
            //alert('successCookie' + displayAfterTime);
            var survey = $('.fa-survey');
            setTimeout(function () { survey.addClass('active'); }, displayAfterTime);
        }

        function errorFunc(error, status) {
            //alert('error' + JSON.stringify(error));
            var survey = $('.fa-survey');
            survey.addClass('active');   //survey will be displayed immediately
        }
    }

   //Ajax call to increment user number
    incrementCurrentUserNumberAjax() {
        if (this.getCookie("sessionNew") != "false") {

            var serviceURL = $(".incrementCurrentUserNumberUrl").text();
            var websiteName = $('.SurveyWebsiteName').text();
            //alert(websiteName);
            $.ajax({
                type: "GET",
                url: serviceURL,
                dataType: "json",
                data: { websiteName: websiteName },
                contentType: "application/json; charset=utf-8",
                success: successFunc,
                error: errorFunc
            });
            function successFunc(data, status) {
                //alert('success' + data);
            }
            function errorFunc(error, status) {
                //alert('error' + JSON.stringify(status + "     " + error));
            }
        }
    }

    //This is browser document.cookie and not fa website cookie(which is based on concept of localstorage)
    getCookie(cname) {
        var name = cname + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    getSurveyAlreadyActionedByUser() {

        let actioned = localStorage.getItem(this.surveyAlreadyActionedByUserKey);
        if (actioned != null && actioned == "True") {
            return true;
        }
        return false;
    }

};






// WEBPACK FOOTER //
// ./components/cookie/scripts/cookie.js